const APIs = {
  GET_ALL: 'admin/roles',
  GET_SINGLE: 'admin/roles/:id',
}

export default APIs
